import { GlobalMediaPlayerModel, MediaPlayersCache } from '@sp/data/global';
import { AudioHistogram } from '@sp/ui/elements';
import { IconPause, IconPlay } from '@sp/ui/icons';
import { UploadableAudioAttachment, ViewAudioAttachment } from '@sp/util/chat-attachments';
import { getMediaDurationString } from '@sp/util/format';
import { useStore } from 'effector-react';
import { FC, useCallback, useMemo } from 'react';

export const EditorAttachmentAudioView: FC<{
  attachment: UploadableAudioAttachment | ViewAudioAttachment;
  authorName: string;
}> = ({ attachment, authorName }) => {
  const duration = useMemo(() => getMediaDurationString(attachment.duration), [attachment.duration]);
  const mediaPlayer = useMemo(
    () => MediaPlayersCache.get(attachment.fileDataUrl ?? attachment.url),
    [attachment.fileDataUrl, attachment.url],
  );
  const { $paused, $progress, play, pause, setProgress } = mediaPlayer;
  const paused = useStore($paused);
  const progress = useStore($progress);

  const togglePlay = useCallback(() => {
    if (!paused) {
      pause();
    } else {
      GlobalMediaPlayerModel.pause();
      GlobalMediaPlayerModel.setPlayer({ player: mediaPlayer, meta: { authorName } });
      play();
    }
  }, [authorName, mediaPlayer, pause, paused, play]);

  return (
    <div className="w-full h-16 p-2 overflow-hidden rounded-1.5lg bg-secondary border border-stroke">
      <div className="flex justify-between items-center gap-2">
        <button
          onClick={togglePlay}
          type="button"
          className="flex flex-none items-center justify-center h-8 w-8 bg-accent rounded-full text-active"
        >
          {!paused ? <IconPause size={16} /> : <IconPlay filled size={16} />}
        </button>
        <AudioHistogram peaks={attachment.histogram ?? []} progress={progress} onSetProgress={setProgress} />
      </div>

      <div className="text-xs ml-10">{duration}</div>
    </div>
  );
};
